export const normalizeArchivePath = (path: string): string =>
  String(path || "")
    .replace(/\\/g, "/")
    .replace(/^\/+/, "")
    .trim();

export const isSafeRelativeArchivePath = (path: string): boolean => {
  const raw = String(path || "").trim();
  if (raw.startsWith("/") || raw.startsWith("\\")) return false;
  const normalized = normalizeArchivePath(path);
  if (!normalized) return false;
  if (/^[a-zA-Z]:\//.test(normalized)) return false;
  return normalized.split("/").every((part) => part && part !== "." && part !== "..");
};
